<template>
  <div class="part-class">
    <div id="footer">
      <div class="part-class-btn">友情链接</div>
      <div class="link">
        <div v-for="(item, index) in links" :key="item.id" class="link-single">
          <el-link
            :href="item.redirect"
            target="_blank"
            :underline="false"
          >{{ item.title | ellipsis(9)}}</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: []
    };
  },
  created() {
    this.getLinks();
  },
  methods: {
    getLinks() {
      this.httpGet(this.$root.getLinks, {})
        .then(result => {
          this.links.push(...result.list);
        })
        .catch(err => {
          console.error('getLinks-err', err);
        });
    },
    top() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.part-class {
  background: white;
  width: 100%
}

.part-class-btn {
  margin-bottom: 16px;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  font-weight bold
}

.footer-link {
  // height: 147px;
  border: 0px solid gray97;
}

.link {
  // flex-x(flex-start);
  width: 100%;
  flex-wrap: wrap;
  min-height: 100px;
}

.link-single {
  // border: 1px solid red;
  width: 160px;
  float: left;
  font-size: 14px;
  line-height: 27px;
  margin-right: 25px;
  ellipsis();
}

>>>.el-link--inner {
  max-width: 211px !important;
  ellipsis();
}
</style>
